import parsePhoneNumber from "libphonenumber-js";
import type { PhoneNumber } from "libphonenumber-js";

export function getNationalPhonenumber(phone?: string, code?: string): string {

    let phonenumber = "";

    code = code || "82";

    if (!phone) { return "" }

    try {
        const parsePhone = parsePhoneNumber(`+${code} ${phone}`) as PhoneNumber;
        phonenumber = parsePhone.isValid() && parsePhone.formatNational() ? parsePhone.formatNational() : phone
    } catch {
        phonenumber = phone
    }

    return phonenumber.replace(/\-/g, '')
}

export function getInternationalPhonenumber(phone?: string, code?: string, minify = true) {
    let phonenumber = "";
    code = code || "82";

    if (!phone) { return '' };

    try {
        const parsePhone = parsePhoneNumber(`+${code} ${phone}`) as PhoneNumber;
        phonenumber = parsePhone.isValid() && parsePhone.formatInternational() ? parsePhone.formatInternational() : phone
    } catch {
        phonenumber = phone
    }

    if (minify) {
        phonenumber = phonenumber.replace(/ /g, '');
        phonenumber = phonenumber.replace(code, '');
        phonenumber = phonenumber.replace("+", '');
    }

    return phonenumber
}

export function addSpacer(value: string, spacer = "-") {
    return value
        .replace(/[^0-9]/g, "")
        .replace(
            /(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/,
            `$1${spacer}$2${spacer}$3`
        )
        .replace(`${spacer}${spacer}`, spacer);
}